import { type Address } from '~/common/types';

import { EMPTY_STRING_FALLBACK } from '~/common/constants';

/**
 * Formats an address for display as "addressLine, postalCode city", falling back gracefully when
 * parts are missing.
 *
 * @param address - Address to format. Only `addressLine`, `city` and `postalCode` are used.
 * @returns The formatted address, or the empty-string fallback when there is no address line.
 */
const getFormattedAddress = ({
  addressLine,
  city,
  postalCode,
}: Partial<Pick<Address, 'addressLine' | 'city' | 'postalCode'>>) => {
  if (!addressLine) return EMPTY_STRING_FALLBACK;

  const parts: string[] = [addressLine];

  if (city && postalCode) parts.push(`${postalCode} ${city}`);
  else if (city) parts.push(city);
  else if (postalCode) parts.push(postalCode);

  return parts.join(', ');
};

export default getFormattedAddress;
